import { useEffect, useState, useContext } from "react";
import styles from "./index.module.scss";
import { useNavigate } from "react-router-dom";
import { tgLink } from "../../constants";
import { AuthContext } from "../../providers/AuthProvider";
import { getDefaultPrivateLeagueId } from "../../helpers/user";

const QuickAccess = () => {
  const [tiles, setTiles] = useState([]);
  const { user } = useContext(AuthContext);

  const navigate = useNavigate();
  const defaultPrivateLeagueId = getDefaultPrivateLeagueId(
    user?.me?.privateLeagues
  );

  useEffect(() => {
    setTiles([
      {
        label: "Правила",
        icon: "paperclip",
        onClick: () => {
          navigate(`/rules`);
        },
      },
      {
        label: "Приватні ліги",
        icon: "incognito",
        onClick: () => {
          navigate(`/private-leagues/${defaultPrivateLeagueId}`);
        },
      },
      {
        label: "Статистика",
        icon: "pie-chart",
        onClick: () => {
          navigate(`/stats`);
        },
      },
      {
        label: "ФЕНТЕЗІ ПЕРША",
        icon: "telegram",
        onClick: () => {
          window.location.href = tgLink;
        },
      },
      {
        label: "Вихід",
        icon: "box-arrow-right",
        onClick: () => {
          navigate(`/logout`);
        },
      },
    ]);
  }, [navigate, defaultPrivateLeagueId]);

  return (
    <div className={styles.cnt}>
      {tiles.map((tile) => (
        <div key={tile.label} className={styles.tile} onClick={tile.onClick}>
          <i className={`bi bi-${tile.icon} ${styles.icon}`}></i>
          <div className={styles.label}>{tile.label}</div>
        </div>
      ))}
    </div>
  );
};

export default QuickAccess;
